// Dashboard Service -- real backend-backed data for the Overview page.
// See GitHub issue #15: these functions used to return hardcoded literals
// ('dreamx.homes', 'Sundara', 'Dayton MLS', etc.) for every single account.
import apiService from './api';

const PLAN_LABELS = {
  free: 'Free',
  basic: 'Basic',
  pro: 'Professional',
  enterprise: 'Enterprise',
};

const dashboardService = {
  // user.subdomain comes from /api/auth/me (routes/auth.js), already fetched
  // by AuthContext on every load -- no extra network call needed here.
  async getWebsiteInfo(user) {
    const sub = user?.subdomain;
    return {
      success: true,
      data: {
        domain: sub?.fullDomain || null,
        status: sub?.status || 'pending',
        template: sub?.template || null,
      }
    };
  },

  async getMLSConnections(orgId) {
    if (!orgId) return { success: true, data: [] };
    const res = await apiService.request(`/api/organizations/${orgId}`);
    const allowedMls = res?.organization?.settings?.allowedMls || [];
    return {
      success: true,
      data: allowedMls.map((code) => ({
        id: code,
        name: code,
        code,
        status: 'connected',
      }))
    };
  },

  async getAnalytics(timeRange = '7days') {
    const res = await apiService.request(`/api/leads/analytics/timeseries?range=${timeRange}`);
    return { success: true, data: res?.data || [] };
  },

  async getTopPages() {
    const res = await apiService.request('/api/leads/analytics/overview');
    return { success: true, data: res?.topPages || [] };
  },

  async getPackageInfo(orgId, fallbackPlan) {
    let plan = fallbackPlan;
    if (orgId) {
      const res = await apiService.request(`/api/organizations/${orgId}`);
      plan = res?.organization?.plan || plan;
    }
    return {
      success: true,
      data: {
        packageName: PLAN_LABELS[plan] || 'Free',
      }
    };
  }
};

export default dashboardService;
